import { Box, Button, CardMedia, CircularProgress, Grid, IconButton, Theme, Typography, useTheme } from '@mui/material';
import { Notes, ProceedSaveLater, SubHeading } from './components';
import {
  Formik,
  FormikHelpers,
  setNestedObjectValues,
  useField,
  validateYupSchema,
  yupToFormErrors,
} from '../../lib/formik/Formik';
import MFSelectField from '../../lib/formik/SelectField';
import React, { useEffect, useState } from 'react';
import {
  AddressProofsMasters,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  applicantStatusMasters,
  APPLICATION_TYPE,
  APPLICATION_TYPE_FOR_DOCUMENTS,
  BankAccountProofsMasters,
  ENABLE_KRA_DOCUMENT_FETCH,
  IdentityProofsMasters,
  IMAGE_UPLOAD_FORMATS,
  INVESTOR_IMAGE_UPLOAD_FORMATS,
  MPOWER_ACCOUNT_TYPE_MASTER,
  NEXEDGE_INVESTMENT_PREFERENCE,
  NOMINEE_OPT_OUT_FEATURE_ENABLED,
  ONBOARDING_DEMAT_DETAILS,
  onboardingTypeMasters,
  USER_ROLES,
} from '../../utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import {
  Applicant,
  Bank,
  Document,
  DocumentType,
  FileType,
  individuals_Poa_nonIndividuals_Documents,
  KraDocumentType,
  NomineeType,
  RiskProfileMaster,
} from '../../redux-store/types/api-types';
import {
  getDocuments,
  isFormValidForSubmission,
  updateApplication,
} from '../../redux-store/actions/application';
import { useHistory, useRouteMatch } from 'react-router';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { documentDetailsSchema } from '../../utils/schema';
import { logout, showError } from '../../redux-store/actions/auth';
import {
  formatFileSize,
  getApplicantName,
  isMinor,
  isModuleAllowed,
  isOnboardingTypeMinor,
  saveForLater,
  sendApplication_Nri,
} from '../../utils/utilityFunctions';
import { getFieldTitle } from '../ApplicationDetails/DocumentDetails';
import { setLabels } from 'react-chartjs-2/dist/utils';
import { applicationComparison, applyRoleBasedStatus } from '../../utils/utilityFunctions';
import { useSnackbar } from 'notistack';
import {
  getMaskedAadhaar,
  getNationalityList,
  MaskedAadhaarResponse,
  riskProfileMasterData,
} from '../../redux-store/actions';
import { nationaliyType } from '../../redux-store/types/mdms';
import { KraDocument } from './kraDocument';
import { LoadingButton } from '@mui/lab';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { DownloadIcon } from '../../assets/SvgIcons';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import dayjs, { Dayjs } from '../../utils/dayjs';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType
);

export const FileUpload = ({
  onFileChange,
  name,
  documentData,
  disabled,
  onFileUpload,
  onFileUploaded,
  fileUploadFormats,
  maxUploadFiles,
  maxFileSize,
  minFileSize,
  multipleFilesCheck,
  children
}: {
  onFileChange: (value: string, documentId: string, removeFile?: boolean) => void;
  name: string;
  documentData: documentDetails;
  disabled: boolean;
  onFileUpload: () => void;
  onFileUploaded: () => void;
  fileUploadFormats: string[];
  maxUploadFiles: number;
  maxFileSize: string;
  minFileSize: string | null;
  multipleFilesCheck: string;
  children?: React.ReactNode
}): JSX.Element => {
  const dispatch = useDispatch()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const theme = useTheme();
  const [field, meta] = useField(name);
  const errorText = meta.error && meta.touched ? meta.error : '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [files, setFiles] = useState<any>([]);
  const authToken = useSelector((store: RootStateType) => store.auth.token);

  const handleFileChange = (name: string, documentId: string) => {

    try {
      onFileChange(name, documentId);
    } catch (e) {
      onFileUploaded();
      console.error((e as Error).message);
    }
  };
  return (
    <>
      {!documentData.file ? (
        <Grid container
          sx={(theme: Theme) => ({
            background: theme.palette.common.white,
            border: `0.5px solid ${theme.palette.text.secondary}80`,
            padding: '30px 25px 25px',
            borderRadius: "10px",
            rowGap: "10px",
            // background: 'red',
            '.filepond--root': {
              fontFamily: `${theme.typography.fontFamily}`
            },
            '.filepond--panel-root': {
              background: theme.palette.common.white,
              // border: `0.5px solid ${theme.palette.text.secondary}80`,
              // padding: '30px',
            },
            '.filepond--credits': { display: 'none' },
            '.filepond--label-action': {
              color: `${theme.palette.primary[500]}`,
              fontFamily: `${theme.typography.fontFamily}`,
              letterSpacing: '0.2px',
              cursor: 'pointer',
              textDecoration: "none",
              fontSize: '14px',
              fontWeight: '500',
            },
            '.filepond--label-format': {
              color: `${theme.palette.text.secondary}`,
              fontWeight: '400',
              paddingLeft: '3px'
            },
            '.filepond-subheading': {
              fontWeight: '400',
              color: `${theme.palette.text.secondary}`,

            },
            '.filepond--drop-label': {
              cursor: disabled ? 'not-allowed' : 'pointer',
              pointerEvents: 'all',

            },
            '.filepond--file': {
              color: '#000',
              flexWrap: 'wrap',
              fontWeight: 500,
            },
            '.filepond--file-wrapper': {
              backgroundColor: theme.palette.primary[50],
            },
            '.delete-icon-container': {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "primary.100",
              borderRadius: "50%",
              padding: "5px",
              cursor: "pointer"
            },
            '.filepond--image-preview-overlay-success': {
              color: theme.palette.primary[100],
            },
            // pt: 3,
          })}
        >
          <Grid item xs={12}>
            <FilePond
              files={files}
              server={{
                process: {
                  url: '/api/files/files',
                  method: 'POST',
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                  onload: (response): string => {
                    const result = JSON.parse(response);
                    result?.name && result?.id && handleFileChange(result.name, result.id);
                    onFileUploaded();
                    return response;
                  },
                },
              }}
              onaddfilestart={() => {
                onFileUpload();
              }}
              onaddfile={(error, file) => {
                if (error) {
                  onFileUploaded();
                }
              }}
              onprocessfile={(error, file) => {
                if (error) {
                  if (error?.code === 401) {
                    dispatch(showError(error?.body ?? ""))
                    dispatch(logout());
                  }
                  onFileUploaded();
                }
              }}
              onupdatefiles={(fileItems) => {
                setFiles(fileItems);
              }}
              onprocessfilerevert={() => {
                onFileChange('', '', true);
              }}
              name="file"
              allowPaste={false}
              minFileSize={minFileSize}
              maxFileSize={maxFileSize}
              // allowMultiple={multipleFilesCheck === 'false'}
              // maxFiles={maxUploadFiles}
              allowMultiple={false}
              maxFiles={1}
              acceptedFileTypes={fileUploadFormats}
              labelIdle={
                `<div class="handle-label-orientation">
                <div class="filepond-icon"><img src="../../../images/filePondIcon.svg" /></div>
                <div>
                  <span class="filepond--label-action"
                    >Click to Upload
                    <span class="filepond--label-format"
                      >${fileUploadFormats?.map((format) => format?.split('/')[1])?.toString()}
                    </span>
                  </span>
                  <div class="filepond-subheading">
                    ${minFileSize ? `(Min. File Size: ${minFileSize}), ` : ''}(Max. File Size: ${maxFileSize})
                  </div>
                </div>
              </div>
              `}
              labelFileTypeNotAllowed={'Invalid file type'}
              labelMaxFileSize={`Max file size is ${maxFileSize}`}
              labelMinFileSize={`Min file size is ${minFileSize}`}
              fileValidateTypeLabelExpectedTypesMap={{
                'image/jpeg': '.jpeg',
                'image/jpg': '.jpg',
                'image/png': '.png',
                'application/pdf': '.pdf',
              }}
              imagePreviewHeight={100}
              disabled={disabled}
              styleItemPanelAspectRatio="0.2"
              iconRemove={`
              <div class="delete-icon-container">
                <img src="../../../images/delete-blue.svg"
              </div>
            `}
            >
            </FilePond>
          </Grid>
          {children}
        </Grid >
      ) : (
        <Grid
          container
          sx={{
            // display: 'flex',
            // justifyContent: 'space-between',
            // alignItems: 'center',
            // border: '1px dashed #AAB2BA',
            border: `0.5px solid ${theme.palette.text.secondary}80`,
            // borderRadius: '6px',
            borderRadius: "10px",
            // mt: '30px',
            // minHeight: '65px',
            padding: "15px 15px 15px 5px",
            background: `${theme.palette.common.white}0D`,
          }}
          columnSpacing="10px"
        >
          <Grid item container justifyContent="center" alignItems="center" xs={2}
          // sx={{ display: 'flex', alignItems: 'center' }}
          >
            <CardMedia
              component="img"
              src={documentData.file.thumbnailUrl || '/images/photo-placeholder.jpg'}
              alt="aadhar"
              width="60"
              height="60"
              sx={{
                // display: 'flex',
                // width: 'unset',
                // mx: 1
                objectFit: "contain"
              }}
            />
          </Grid>
          <Grid item container xs={6}>
            {/* <Typography
              component="span"
              sx={{ whiteSpace: 'pre-wrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 }}>
              {documentData.file.name}
            </Typography>
            <Button
              sx={{
                color: `${theme.palette.primary[900]}`,
              }}
              onClick={() => window.open(documentData.file?.viewUrl)}>
              Click to view
            </Button> */}
            <Grid item xs={12}>
              <Typography
                variant='subtitle_500'
                color="text.primary"
              >
                {documentData?.file?.name ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant='overline_400'
                color="text.secondary"
              >
                {formatFileSize(documentData?.file?.size)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                component="span"
                // variant='overline_600'
                // color="primary.500"
                onClick={() => window.open(documentData.file?.viewUrl)}
                sx={{ cursor: "pointer", color: `${theme.palette.primary[500]}`, ...theme.typography.overline_600 }}
                aria-label='Click to view Document'
                role='link'
              >
                Click to view
              </Button>
            </Grid>
          </Grid>
          <Grid
            item
            container
            // sx={{
            //   display: 'flex',
            //   '.MuiButton-root': { fontWeight: 500, fontSize: 14, p: 0, mr: 1 },
            //   flexWrap: 'wrap',
            // }}
            xs={4}
          >
            {/* <Button
              sx={{
                color: 'primary.main',
                border: '1px dashed #2057A6',
                mb: 1,
              }}
              onClick={() => window.open(documentData.file?.viewUrl)}>
              View
            </Button> */}
            <Grid item container justifyContent="flex-end" alignItems="center" xs={12}>
              {/* <IconButton
                sx={{
                  p: 0,
                  pr: 0.5,
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                  cursor: 'pointer',
                  pointerEvents: 'all',
                  mb: 1,
                }}
                onClick={() => window.open(documentData.file?.url, '_blank')}>
                <CardMedia
                  component="img"
                  src={'/images/download-icon.png'}
                  alt="Download"
                  sx={{ width: '25px' }}
                />
              </IconButton> */}
              <IconButton
                aria-label='Download document'
                onClick={() => window.open(documentData.file?.url, '_blank')}
                sx={{ cursor: "pointer" }}
              >
                <DownloadIcon />
              </IconButton>
            </Grid>
            {!disabled && (
              <Grid item container justifyContent="flex-end" alignItems="center" xs={12}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    onFileChange('', '', true);
                  }}
                  sx={(theme: Theme) => ({
                    // mb: 1, 
                    borderRadius: "5px",
                    backgroundColor: theme.palette.primary[50],
                    border: `0.5px solid ${theme.palette.primary[500]}`,
                    color: theme.palette.primary[500],
                    ...theme.typography.subtitle_600,
                    padding: "5px 10px"
                  })}>
                  Replace
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid >
        // <>
        //   <Typography>HI</Typography>
        // </>

      )}
      {
        !!errorText && (
          <Typography
            sx={{
              color: '#d32f2f',
              fontSize: '0.75rem',
            }}>
            {errorText}
          </Typography>
        )
      }
    </>
  );
};

type documentDetails = {
  documentType: string;
  documentName: string;
  documentId: string;
  id?: string | number;
  isActive: boolean;
  file?: FileType;
  loading?: boolean;
  required: string;
  uniqueKey: string;
  options?: string[];
  expiryDate?: Dayjs | null;

  [key: string]: string | number | boolean | FileType | undefined | string[] | null | boolean | Dayjs;
};

type documentProps = {
  documents: {
    documentType: string;
    expiryDate?: Dayjs | null;
    documentName: string;
    documentsList: documentDetails[];
    multipleFiles: string;
    required: string;
    options?: string[];
    uploadFormats: string[];
    maxFiles: number;
    maxFileSize: string;
    minFileSize: string;
    isDisplay: boolean; //to be uncommented for nexedge
    url?: string;
  }[];
  kraDocument?: KraDocumentType[];
  onboardingType?: any;
  permanentAddressEdited?: boolean;
};

type nomineeDocumentProps = {
  nomineedocuments: {
    documentType: string;
    documentName: string;
    documentsList: documentDetails[];
    multipleFiles: string;
    required: string;
    options?: string[];
    uploadFormats: string[];
    maxFiles: number;
    maxFileSize: string;
    minFileSize: string;
  }[];
};
export interface Values {
  applicants: documentProps[];
  nominees: nomineeDocumentProps[];
  saveType: string;
  banks: Bank[];
  hasPOA: boolean;
  [key: string]:
  | documentProps[]
  | string
  | undefined
  | string[]
  | Bank[]
  | boolean
  | nomineeDocumentProps[];
}

interface DocumentObj {
  documentType: string;
  documentName: string;
  documentsList: documentDetails[];
  multipleFiles: string;
  required: string;
  options?: string[];
  uploadFormats: string[];
  maxFiles: number;
  maxFileSize: string;
  minFileSize: string;
}

export const document_object = {
  documentId: '',
  isActive: true,
};
export default function DocumentDetails(): JSX.Element {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const dispatch = useDispatch();
  const history = useHistory();
  const [documentUpload, setDocumentUpload] = useState(false);
  const { path: currentPath } = useRouteMatch();

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  const isHeldAway = MPOWER_ACCOUNT_TYPE_MASTER[`${application?.accountType ?? ""}`?.toUpperCase()] === MPOWER_ACCOUNT_TYPE_MASTER['HLDAWY'];

  // In case of Nominee Otp out, nominee opt out document is required
  // When doNotWishToNominate = true and isBSEEnabled = true and isNomineeOptOutAuthenticated != '1'

  const isNomineeOptOutAuthRequired = application?.doNotWishToNominate && application?.isBSEEnabled && (application?.isNomineeOptOutAuthenticated !== '1')

  const handleUpload = () => {
    setDocumentUpload(true);
  };
  const handleUploaded = () => {
    setDocumentUpload(false);
  };
  const [documentsData, setDocumentsData] = useState<Document>();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getDocuments())) as unknown as Document;
        const modifiedReponse = {
          ...response,
          individual: response.individual.map(obj => {
            if (obj.documentType === "identityProof")
              return { ...obj, documentName: "ID Proof" }
            else
              return obj
          })
        }

        setDocumentsData(modifiedReponse as Document);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  const { applicants = [], banks = [], hasPOA = true, nominees = [], riskProfileGroup } = application || {};

  const getCurrentDocumentValue = (
    currentDocuments: DocumentObj[],
    docType: string,
    index: number
  ) => {
    return currentDocuments.find(doc => doc.documentType === docType)?.documentsList[index]?.documentName ?? "";
  }

  const refactorDocumentArray = (
    doc: DocumentObj,
    currentDocumentType: string,
    documentListIndex: number,
    existingValue: string,
    currentOption: string,
    permanentAddressEdited = false
  ) => {
    if (doc.documentType === 'aadhaar_card') {
      const aadhaarRequired = isHeldAway ? "false" :
        ((existingValue === "Aadhaar Card" || currentOption === 'Aadhaar Card') ? 'false' : 'true');

      const finalAadhaarRequired = (`${application?.onboardingVia ?? ""}`.toLowerCase() === 'digital') ? "false" : aadhaarRequired;

      return {
        ...doc,
        documentsList: doc.documentsList.map((obj, index) => {
          return index === documentListIndex ? {
            ...obj,
            required: finalAadhaarRequired
          } : obj
        }),
        required: finalAadhaarRequired,
        isDisplay: (existingValue === "Aadhaar Card" || currentOption === 'Aadhaar Card') ? false : true, //to be uncommented for nexedge
      };
    }
    else if (doc.documentType === 'pan_card') {
      return {
        ...doc,
        documentsList: doc.documentsList.map((obj, index) => {
          return index === documentListIndex ? {
            ...obj,
            required: isHeldAway ? "false" : ((existingValue === "PAN Card" || currentOption === 'PAN Card') ? 'false' : 'true')
          } : obj
        }),
        required: isHeldAway ? "false" : ((existingValue === "PAN Card" || currentOption === 'PAN Card') ? 'false' : 'true'),
        isDisplay: (existingValue === "PAN Card" || currentOption === 'PAN Card') ? false : true,
        //to be uncommented for nexedge
      };
    }
    else if (doc.documentType === currentDocumentType) {
      return {
        ...doc,
        documentsList: doc.documentsList.map((obj, index) => {
          return index === documentListIndex ? {
            ...obj,
            required: isHeldAway ? "false" : ((currentOption === "Aadhaar Card" || currentOption === 'PAN Card' || permanentAddressEdited) ? 'true' : 'false')
          } : obj
        }),
        required: isHeldAway ? "false" : ((currentOption === "Aadhaar Card" || currentOption === 'PAN Card' || permanentAddressEdited) ? 'true' : 'false')
      };
    }
    return doc;
  }

  const handleIdentityProofChange = (
    applicantIndex: number,
    documentListIndex: number,
    selectedOption: string,
    values: Values,
    setFieldValue: FormikHelpers<Values>['setFieldValue'],
    currentDocumentType: string,
    permanentAddressEdited = false
  ) => {
    const currentDocuments = values.applicants[applicantIndex].documents;

    const currentIdProofValue = getCurrentDocumentValue(currentDocuments, 'identityProof', documentListIndex);
    const currentAddressProofValue = getCurrentDocumentValue(currentDocuments, 'addressProof', documentListIndex);

    const updatedDocuments = currentDocuments.map(
      (doc: DocumentObj) => {
        if (currentDocumentType === "identityProof") {
          return refactorDocumentArray(doc, currentDocumentType, documentListIndex, currentAddressProofValue, selectedOption)
        } else if (currentDocumentType === "addressProof") {
          return refactorDocumentArray(doc, currentDocumentType, documentListIndex, currentIdProofValue, selectedOption, permanentAddressEdited)
        }
      }
    );

    setFieldValue(`applicants.${applicantIndex}.documents`, updatedDocuments);
  };

  const initialValues: Values = {
    applicants: applicants.map((applicant, applicant_index) => {

      const existingIdProofValue = applicant?.documents?.find(obj => obj.documentType === "identityProof")?.documentName ?? ""

      const existingAddressProofValue = applicant?.documents?.find(obj => obj.documentType === "addressProof")?.documentName ?? ""

      const permanentAddressEdited = applicant?.permanentAddressEdited;

      let docData = '';
      if (
        !hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        if (
          onboardingTypeMasters[applicants[0].onboardingType as string] ===
          onboardingTypeMasters.minor
        ) {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.MINOR;
        } else {
          docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
        }
      }
      if (
        hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
      }
      if (
        !hasPOA &&
        // applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
        (
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRE ||
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRO
        )
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
      }
      if (
        hasPOA &&
        // applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
        (
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRE ||
          applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRO
        )
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
      }
      return {
        documents:
          typeof documentsData !== 'undefined'
            ? ((documentsData as Document)[docData] || [])
              .map(obj => ({ ...obj, isDisplay: true })) //to be uncommented for nexedge
              .filter((doc) => {
                if (
                  hasPOA &&
                  applicant.applicant_type !== '1' &&
                  doc.documentType === 'poaNotarized'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .filter((document) => {
                if (applicant.amlCheck && document.documentType === 'compliance_document') {
                  return;
                }
                return document;
              })
              .filter((ele) => ele)
              .filter((doc) => {
                if (
                  !applicant.correspondenceAddressEdited &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (
                  applicant.correspondenceAddressEdited &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              .map((doc) => {
                if (applicant.permanentAddressEdited && doc.documentType === 'addressProof') {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              // NEEDS TO BE COMMENTED OUT FOR BPI CLIENT START
              .map((doc) => {
                if (doc.documentType === "identityProof") {
                  return { ...doc, required: (existingIdProofValue === "Aadhaar Card" || existingIdProofValue === "PAN Card") ? "true" : "false" }
                }
                if (doc.documentType === 'addressProof') {
                  return { ...doc, required: (existingAddressProofValue === "Aadhaar Card" || existingAddressProofValue === "PAN Card" || permanentAddressEdited) ? "true" : "false" }
                }
                if (doc.documentType === 'aadhaar_card') {
                  const aadhaarRequired = (existingIdProofValue === "Aadhaar Card" || existingAddressProofValue === "Aadhaar Card") ? "false" : "true";

                  const finalAadhaarRequired = (`${application?.onboardingVia ?? ""}`.toLowerCase() === 'digital') ? "false" : aadhaarRequired;

                  return {
                    ...doc,
                    required: finalAadhaarRequired,
                    isDisplay: (existingIdProofValue === "Aadhaar Card" || existingAddressProofValue === "Aadhaar Card") ? false : true, //to be uncommented for nexedge
                  }
                }
                if (doc.documentType === 'pan_card') {
                  return {
                    ...doc,
                    required: (existingIdProofValue === "PAN Card" || existingAddressProofValue === "PAN Card") ? "false" : "true",
                    isDisplay: (existingIdProofValue === "PAN Card" || existingAddressProofValue === "PAN Card") ? false : true, //to be uncommented for nexedge
                  }
                }
                if (doc.documentType === "investorSignature") {
                  return {
                    ...doc,
                    required: (application?.onboardingVia?.toLowerCase() === 'physical' && application?.isBSEEnabled)
                      || (application?.onboardingVia?.toLowerCase() === 'digital')
                      ? "true"
                      : "false"

                  }
                }
                if (doc.documentType === "court_proof_of_guardian") {
                  return { ...doc, required: (applicant?.guardianRelationship === "COURT APPOINTED LEGAL GUARDIAN") ? "true" : "false" }
                }

                // Physical Signed Doc is required when isEsignEnabled is false and it is first applicant => start

                if (doc.documentType === 'physical_signed_document') {
                  return {
                    ...doc,
                    required: (
                      (application?.isEsignEnabled === false) &&
                      (applicant?.applicant_type === '1')
                    ) ? 'true' : 'false'
                  }
                }

                // Physical Signed Doc is required when isEsignEnabled is false and it is first applicant => end

                // KYC Fetch Consent Proof is mandatory only when accountType is POA or EXECUTIONARY and onboardingVia is 'physical' => START
                if (doc.documentType === 'kycFetchConsentProof') {
                  const currentAccountType = MPOWER_ACCOUNT_TYPE_MASTER[`${application?.accountType ?? ""}`?.toUpperCase()];
                  const isPOAOrExecutionary = [MPOWER_ACCOUNT_TYPE_MASTER['POA'], MPOWER_ACCOUNT_TYPE_MASTER['EXECUTIONARY']].includes(currentAccountType)

                  return {
                    ...doc,
                    required: (isPOAOrExecutionary && `${application?.onboardingVia ?? ""}`.toLowerCase() === 'physical')
                      ? 'true'
                      : 'false'
                  }
                }
                // KYC Fetch Consent Proof is mandatory only when accountType is POA or EXECUTIONARY and onboardingVia is 'physical' => END

                return doc
              })
              // NEEDS TO BE COMMENTED OUT FOR BPI CLIENT END

              // Bank Account Proof is there only for first applicant start

              .filter((doc) => {
                if (doc.documentType === "bankAccountProof" && applicant?.applicant_type !== "1") {
                  return
                }

                return doc
              })

              // Bank Account Proof is there only for first applicant end

              // Nominee Opt Out Document Start

              // Enabling Nominee Opt Out Document based on feature flag

              .filter((doc) => {
                if (doc.documentType === "nominee_opt_out" && !NOMINEE_OPT_OUT_FEATURE_ENABLED) {
                  return
                }

                return doc
              })

              // Nominee Opt Out Document is there only for individual onboarding
              .filter((doc) => {
                if (
                  doc.documentType === "nominee_opt_out" &&
                  !(
                    isModuleAllowed({ value: (application?.onboardingType ?? ""), compareArr: [onboardingTypeMasters.normal] }) &&
                    isModuleAllowed({ value: (application?.applicationType ?? ""), compareArr: [APPLICATION_TYPE.INDIVIDUAL] })
                  )
                ) {
                  return
                }

                return doc
              })
              // Nominee Opt Out Document is there only for first applicant
              .filter((doc) => {
                if (doc.documentType === "nominee_opt_out" && applicant?.applicant_type !== "1") {
                  return
                }

                return doc
              })
              // Making Nominee Opt Out document required based on isNomineeOptOutAuthRequired condition
              .map((doc) => {
                if (doc.documentType === "nominee_opt_out" && isNomineeOptOutAuthRequired) {
                  return { ...doc, required: "true" }
                }
                return doc
              })

              // Nominee Opt Out Document End

              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const {
                  documentType,
                  documentName,
                  multipleFiles,
                  required,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                  minFileSize,
                  isDisplay, //to be uncommented for nexedge
                  url = ""
                } = doc;
                const { documents: existingDocuments = [] } = applicant || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                      const {
                        id,
                        documentName = '',
                        documentType = '',
                        documentId = '',
                        isActive = true,
                        file = undefined,
                        loading = false,
                      } = doc;
                      return {
                        id,
                        applicantId: applicant?.id,
                        documentType,
                        documentName,
                        loading,
                        documentId,
                        isActive,
                        file,
                        options,
                        required: isHeldAway ? "false" : required,
                        maxFiles,
                        uniqueKey: (applicant_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          ind.toString()) as string,
                        expiryDate: doc?.expiryDate ? dayjs(doc?.expiryDate) : null
                      };
                    })
                    : [
                      {
                        documentType,
                        documentName,
                        required: isHeldAway ? "false" : required,
                        options,
                        uniqueKey: (applicant_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          '0') as string,
                        maxFiles,
                        expiryDate: null,
                        ...document_object,
                      },
                    ],
                  required: isHeldAway ? "false" : required,
                  multipleFiles,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                  minFileSize,
                  isDisplay, //to be uncommented for nexedge,
                  url
                };
              })
            : [],
        kraDocument: applicant.kraDocument,
        onboardingType: applicant.onboardingType,
        permanentAddressEdited: permanentAddressEdited
      };
    }),
    nominees: nominees.map((nominee, nominee_index) => {
      return {
        nomineedocuments:
          typeof documentsData !== 'undefined'
            ? (isMinor(nominee.dateOfBirth || '')
              ? [
                ...((documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] ||
                  []),
                ...((documentsData as Document)[
                  APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_GUARDIAN
                ] || []),
              ].map((doc) => {
                if (doc.documentType === 'nomineeIdProof') {
                  return { ...doc, required: 'false' };
                }
                return doc;
              })
              : (documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] || []
            )
              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const {
                  documentType,
                  documentName,
                  multipleFiles,
                  required,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                  minFileSize,
                } = doc;
                const { nomineedocuments: existingDocuments = [] } = nominee || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                      const {
                        id,
                        documentName = '',
                        documentType = '',
                        documentId = '',
                        isActive = true,
                        file = undefined,
                      } = doc;
                      return {
                        id,
                        nomineeId: nominee?.id,
                        documentType,
                        documentName,
                        documentId,
                        isActive,
                        file,
                        options,
                        required: isHeldAway ? "false" : required,
                        uniqueKey: (nominee_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          ind.toString()) as string,
                      };
                    })
                    : [
                      {
                        documentType,
                        documentName,
                        required: isHeldAway ? "false" : required,
                        options,
                        uniqueKey: (nominee_index.toString() +
                          '-' +
                          index.toString() +
                          '-' +
                          '0') as string,
                        ...document_object,
                      },
                    ],
                  required: isHeldAway ? "false" : required,
                  multipleFiles,
                  options,
                  uploadFormats,
                  maxFiles,
                  maxFileSize,
                  minFileSize,
                };
              })
            : [],
      };
    }),
    saveType: 'save and proceed',
    banks: banks,
    hasPOA: hasPOA,
  };
  const updatedApplicants = (
    exisitingApplicants: Partial<Applicant>[],
    applicants: documentProps[]
  ): Partial<Applicant>[] => {
    return exisitingApplicants.map((applicant, index) => {
      const { documents = [] } = applicants[index] || {};

      const expiryDateMap = {} as any;

      const finalDocs = documents
        .filter(obj => obj.isDisplay) //to be uncommented for nexedge
        .map((doc) => {
          return doc.documentsList.filter((d) => d.documentId);
        })
        .flat()
        .map((doc) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { uniqueKey, required, ...rest } = doc;
          return {
            ...rest,
            expiryDate: doc?.expiryDate ? doc?.expiryDate?.toISOString() : null
            // id: applicant?.documents?.find((doc) => doc.documentType === rest.documentType)?.id,
            // applicantId: applicant?.id,
          };
        })
        .map((doc) => {
          expiryDateMap[doc.documentType] = expiryDateMap[doc.documentType] ?? doc.expiryDate
          return {
            ...doc,
            expiryDate: expiryDateMap[doc.documentType]
          }
        })
      return {
        ...applicant,
        documents: finalDocs,
      };
    }) as Partial<Applicant>[];
  };

  const updatedNominees = (
    existingNominees: NomineeType[],
    nominees: nomineeDocumentProps[]
  ): NomineeType[] => {
    return existingNominees.map((nominee, index) => {
      const { nomineedocuments = [] } = nominees[index] || {};
      const finalDocs = nomineedocuments
        .map((doc) => {
          return doc.documentsList.filter((d) => d.documentId);
        })
        .flat()
        .map((doc) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { uniqueKey, required, ...rest } = doc;
          return {
            ...rest,
            // nomineeId: nominee?.id,
            // id: nominee?.nomineedocuments?.find((doc) => doc.documentType === rest.documentType)
            //   ?.id,
          };
        });
      return {
        ...nominee,
        nomineedocuments: finalDocs,
      };
    }) as NomineeType[];
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      const nationalitiesMdmsMasters = (await dispatch(
        getNationalityList()
      )) as unknown as nationaliyType;
      const responseRiskProfile = (await dispatch(
        riskProfileMasterData({
          riskProfileGroup: riskProfileGroup ?? null,
          company: application?.company ?? null
        })
      )) as unknown as RiskProfileMaster;
      await isFormValidForSubmission(
        application,
        false,
        true,
        nationalitiesMdmsMasters,
        documentsData,
        role,
        responseRiskProfile.riskProfile,
        currencyCode,
        company
      );
      const {
        applicants: exisitingApplicants = [],
        id,
        applicant1ReferenceId,
        currentStep,
        status,
        applicationNumber,
        nominees: existingNominees = [],
      } = application || {};
      const { applicants, saveType, hasPOA, nominees } = values;

      // const updatedApplicants = exisitingApplicants.map((applicant, index) => {
      //   const applicantsWithNoDocsAttached = Object.keys(applicants[index].documents).filter(
      //     (doc) => applicants[index].documents[doc].documentId
      //   );
      //   return {
      //     ...applicant,
      //     countryCode: '+91', //For now hard coding country code. Need to remove after UI is done
      //     documents: applicantsWithNoDocsAttached.map((documentType) => ({
      //       ...getExistingDocuments(exisitingApplicants[index].documents || [], documentType),
      //       ...applicants[index].documents[documentType],
      //     })),
      //   };
      // });

      const updatedApplicantsWithDoc = updatedApplicants(exisitingApplicants, applicants);
      updatedApplicantsWithDoc.map((applicant) => {
        if (applicant.documents?.length) {
          applicant.documents.map((document) => {
            if (document.options && !document.options.includes(document.documentName)) {
              throw `Please Select ${getFieldTitle[document.documentType]}`;
            }
          });
        }
      });

      const updatedNomineesWithDoc = updatedNominees(existingNominees, nominees);
      updatedNomineesWithDoc.map((_nominee) => {
        if (_nominee.nomineedocuments?.length) {
          _nominee.nomineedocuments.map((document) => {
            if (document.options && !document.options.includes(document.documentName)) {
              throw `Please Select ${getFieldTitle[document.documentType]}`;
            }
          });
        }
      });
      const checkApplication = applicationComparison(
        {
          ...application,
          applicants: application?.applicants
            ?.map((applicant) => {
              return {
                ...applicant,
                documents: applicant.documents
                  ?.map((document: any) => {
                    const {
                      documentData,
                      // id,
                      // applicantId,
                      filename,
                      updatedAt,
                      createdAt,
                      updatedBy,
                      createdBy,
                      ...rest
                    } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          nominees: application?.nominees
            ?.map((nominee) => {
              return {
                ...nominee,
                nomineedocuments: nominee.nomineedocuments
                  ?.map((document: any) => {
                    const {
                      documentData,
                      // id,
                      // nomineeId,
                      filename,
                      updatedAt,
                      createdAt,
                      updatedBy,
                      createdBy,
                      ...rest
                    } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)),
        },
        {
          ...application,
          applicants: updatedApplicantsWithDoc
            .map((applicant) => {
              return {
                ...applicant,
                documents: applicant.documents
                  ?.map((document: any) => {
                    const { documentData, options, loading, ...rest } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          nominees: updatedNomineesWithDoc
            .map((nominee) => {
              return {
                ...nominee,
                nomineedocuments: nominee.nomineedocuments
                  ?.map((document: any) => {
                    const { documentData, options, ...rest } = document;
                    return { ...rest };
                  })
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId)),
              };
            })
            .sort((nominee1, nominee2) => Number(nominee1.id) - Number(nominee2.id)),
          currentStep: !!currentStep && currentStep > (
            ONBOARDING_DEMAT_DETAILS
              ? (NEXEDGE_INVESTMENT_PREFERENCE ? 11 : 12)
              : (NEXEDGE_INVESTMENT_PREFERENCE ? 10 : 11)
          ) ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';

      let currentStatus = status

      if (
        !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
        status === 'sent_to_amc_approver'
      ) {
        currentStatus = 'draft'
      } else if (
        !application?.hasPOA &&
        AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
        applyRoleBasedStatus(role) &&
        status !== 'draft'
      ) {
        currentStatus = 'sent_to_amc_approver'
      }

      if (id && !checkApplication) {
        const response = await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedApplicantsWithDoc,
              nominees: updatedNomineesWithDoc,
              // : (status === 'draft' || status === 'sent_to_amc_approver') &&
              status: currentStatus,
              currentStep: (ONBOARDING_DEMAT_DETAILS
                ? (NEXEDGE_INVESTMENT_PREFERENCE ? 12 : 13)
                : (NEXEDGE_INVESTMENT_PREFERENCE ? 11 : 12)
              ),
              //!!currentStep && currentStep > 8 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && {
              toastMessage: '',
            }),
          })
        );

        if (!response) return;

        if (Object.keys(response ?? {}).length) {
          if (isDiyInvestorOnboarding) {
            if (isSaveLater) {
              history.push(`/investor-onboarding-application-details/${id}`)
            } else {
              history.push(`/investor-onboarding-application-preview/${id}`)
            }
            return
          }

          history.push(
            role === USER_ROLES.INVESTOR
              ? `/investment-details/${applicant1ReferenceId}/application-details`
              : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
                ? `/application-details/${id}`
                : isSaveLater
                  ? `/applications`
                  : `/application-preview/${id}`
          );
        }
      } else if (isSaveLater) {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        history.push(
          role === USER_ROLES.INVESTOR
            ? `/investment-details/${applicant1ReferenceId}/application-details`
            : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
              ? isDiyInvestorOnboarding ? `/investor-onboarding-application-details/${id}` : `/application-details/${id}`
              : `/applications`
        );
      } else {
        history.push(
          isDiyInvestorOnboarding ? `/investor-onboarding-application-preview/${id}` :
            role === USER_ROLES.INVESTOR
              ? `/investment-details/${applicant1ReferenceId}/application-details`
              : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
                ? `/application-details/${id}`
                : `/application-preview/${id}`
        );
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const isFieldDisabled = isDiyInvestorOnboarding ? false : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);
  const getLabel = (
    documentName: string,
    documentType: string,
    required: string,
    values: Values,
    ind: number
  ): string => {
    // return `${documentName}  ${documentType === 'bankAccountProof'
    //   ? ((!isOnboardingTypeMinor((applicants[0]?.onboardingType as string) || '') &&
    //     values.banks.filter((bank) => !bank.pennydropVerified && bank.defaultBankAccount)
    //       .length !== 0) ||
    //     isOnboardingTypeMinor((applicants[0].onboardingType as string) || '')) &&
    //     ind === 0
    //     ? '*'
    //     : ''
    //   : required === 'true'
    //     ? '*'
    //     : ''
    //   } `;

    return `${documentName}  ${required === 'true' ? '*' : ''} `;
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      //validationSchema={documentDetailsSchema}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, documentDetailsSchema, true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({
        handleSubmit,
        values,
        setValues,
        validateForm,
        setTouched,
        setErrors,
        setFieldValue,
      }) => (
        <Grid
          container
          rowSpacing={3}
          columnSpacing={3}
          component="form"
          noValidate
          onSubmit={handleSubmit}
          alignItems={'center'}
        // sx={{
        //   width: '100%',
        //   ml: 0,
        //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
        // }}
        >
          <Grid item xs={12}>
            <Notes
              displayContent={'Please upload latest documents not more than 2 months old'}
              displayContent1={"Please don't upload any password protected files"}
            />
          </Grid>

          {values.applicants.map((applicant, ind) => {
            const { documents, permanentAddressEdited = false } = applicant;

            return (
              <>

                <Grid item xs={12}>
                  <SubHeading>Applicant {ind + 1} Document Details</SubHeading>
                </Grid>
                {documents.map((document, doc_index) => {
                  const {
                    documentType,
                    documentName,
                    documentsList = [],
                    multipleFiles,
                    options,
                    required,
                    uploadFormats,
                    maxFiles,
                    maxFileSize,
                    minFileSize,
                    isDisplay, //to be uncommented for nexedge
                    url = ""
                  } = document;
                  return (
                    <React.Fragment key={`mainFrag-${ind}`}>
                      <Grid
                        item
                        xs={12}
                        lg={6}
                        sx={{ display: isDisplay ? 'block' : 'none' }} //to be uncommented for nexedge
                      >
                        {options &&
                          documentsList.map((doc, index) => {
                            if (index === 0) {
                              return (
                                <React.Fragment key={`internalFrag-${index}`} >
                                  <Grid xs={12} sm={12}>
                                    <Typography
                                      variant='body_500'
                                      color="text.primary"
                                    >
                                      {getLabel(
                                        documentName,
                                        documentType,
                                        required,
                                        values,
                                        ind
                                      )}
                                    </Typography>
                                    <SearchableSelect
                                      name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentName`}
                                      items={options.map((item: string) => ({
                                        key: item,
                                        value: item,
                                      }))}
                                      // applyLabelStyles={true}
                                      disabled={isFieldDisabled}
                                      onChange={async (event) => {
                                        await setErrors({}) //needs to be commented for BPI client

                                        //needs to be commented for BPI client start
                                        if (documentType === 'identityProof' || documentType === 'addressProof') {
                                          handleIdentityProofChange(ind, index, event.target.value as string, values, setFieldValue, documentType, permanentAddressEdited);
                                        }
                                        //needs to be commented for BPI client end
                                        setFieldValue(
                                          `applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentName`,
                                          event.target.value
                                        );

                                        if (
                                          !isModuleAllowed({ value: ((event?.target?.value as string) ?? ""), compareArr: ["Driving License", "Passport Number"] })
                                        ) {
                                          setFieldValue(
                                            `applicants.${ind}.documents.${doc_index}.documentsList.${index}.expiryDate`,
                                            null
                                          );
                                        }
                                      }}
                                    />
                                    {url && (
                                      <Button
                                        variant="contained"
                                        sx={{ p: 0.8, mt: 1 }}
                                        onClick={() => window.open(`${window.location.origin}` + url, '_blank')}
                                      >
                                        <Typography variant='overline_400'>Download Form</Typography>
                                      </Button>
                                    )}
                                    {(
                                      isModuleAllowed({ value: (doc?.documentName ?? ""), compareArr: ["Driving License", "Passport Number"] })
                                    ) &&
                                      (
                                        <TextDatePicker
                                          name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.expiryDate`}
                                          label="Expiry Date"
                                          inputLabelStyles={{
                                            transform: 'unset',
                                            fontSize: 14,
                                            fontWeight: 500,
                                            color: 'rgba(0,0,0,0.7)',
                                          }}
                                          placeholder=''
                                          disabled={false}
                                          maxDate={new Date("2099-12-31")}
                                        />
                                      )}
                                  </Grid>
                                </React.Fragment>
                              )
                            }
                            return null
                          })}
                        {!options && (
                          <>
                            <Typography
                              sx={{
                                color: `${theme.palette.text.primary}`,
                                fontWeight: 500,
                                fontSize: '16px',
                                fontFamily: `${theme.typography.fontFamily}`,
                                mt: documentType === 'investorSignature' ? 6 : 8,
                              }}>
                              {documentName} {required === 'true' ? '*' : ''}
                              {documentType === 'investorSignature' && (
                                <Typography
                                  sx={{
                                    color: `${theme.palette.text.secondary}`,
                                    fontWeight: 400,
                                    fontSize: 14,
                                    fontFamily: `${theme.typography.fontFamily}`
                                  }}>
                                  (This signature copy is used as a verification process for future
                                  redemptions and transfer requests)
                                </Typography>
                              )}
                            </Typography>
                            {url && (
                              <Button
                                variant="contained"
                                sx={{ p: 0.8, mt: 1 }}
                                onClick={() => window.open(`${window.location.origin}` + url, '_blank')}
                              >
                                <Typography variant='overline_400'>Download Form</Typography>
                              </Button>
                            )}
                            {
                              documentsList.map((doc, index) => (
                                <>
                                  {
                                    isModuleAllowed({ value: (doc?.documentName ?? ""), compareArr: ["Driving License", "Passport Number"] }) && (
                                      <TextDatePicker
                                        name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.expiryDate`}
                                        label="Expiry Date"
                                        inputLabelStyles={{
                                          transform: 'unset',
                                          fontSize: 14,
                                          fontWeight: 500,
                                          color: 'rgba(0,0,0,0.7)',
                                        }}
                                        placeholder=''
                                        disabled={false}
                                        maxDate={new Date("2099-12-31")}
                                      />
                                    )}
                                </>
                              ))}
                          </>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        lg={6}
                        sx={{
                          display: isDisplay ? 'flex' : 'none', //to be uncommented for nexedge
                          flexDirection: "column",
                          rowGap: "10px"
                        }}
                      >
                        {documentsList.map((doc, index) => (
                          <React.Fragment key={doc.uniqueKey}>
                            <FileUpload
                              onFileChange={(value, documentId, removeFile) => {
                                const { file, ...rest } =
                                  values.applicants[ind].documents[doc_index].documentsList[index];
                                setFieldValue(
                                  `applicants.${ind}.documents.${doc_index}.documentsList.${index}`,
                                  {
                                    ...rest,
                                    documentId,
                                    ...(!removeFile && { file }),
                                  }
                                );
                              }}
                              name={`applicants.${ind}.documents.${doc_index}.documentsList.${index}.documentId`}
                              documentData={doc}
                              disabled={isFieldDisabled}
                              onFileUpload={handleUpload}
                              onFileUploaded={handleUploaded}
                              fileUploadFormats={uploadFormats}
                              maxUploadFiles={maxFiles}
                              maxFileSize={maxFileSize}
                              minFileSize={minFileSize}
                              multipleFilesCheck={multipleFiles}
                            >
                              {[
                                'identityProof',
                                'aadhaar_card',
                                'addressProof',
                                'correspondenceAddress',
                              ].includes(doc.documentType) && (
                                  <Grid container item justifyContent="flex-end">
                                    {/* <LoadingButton
                                          loadingPosition="start"
                                          type="submit"
                                          loading={
                                            values.applicants[ind].documents[doc_index].documentsList[index]
                                              .loading
                                          }
                                          variant="contained"
                                          sx={(theme: Theme) => ({
                                            // mt: 1,
                                            // float: 'right',
                                            // fontSize: 15,
                                            // pl: values.applicants[ind].documents[doc_index].documentsList[
                                            //   index
                                            // ].loading
                                            //   ? 5
                                            // : 1,
                                            // py: 0.5,
                                            // cursor:
                                            //   !doc.documentName.includes('Aadhaar Card') ||
                                            //     doc.documentId === ''
                                            //     ? 'none'
                                            //     : 'pointer',
                                            ...theme.typography.subtitle_600,
                                            color: theme.palette.primary[500],
                                            backgroundColor: theme.palette.primary[50],
                                            borderRadius: "5px",
                                            border: `0.5px solid ${theme.palette.primary[500]}`,
                                            padding: "5px 15px",
                                            '&:hover': {
                                              backgroundColor: theme.palette.primary[50],
                                              opacity: 0.7
                                            },
                                            "&.Mui-disabled": {
                                              border: "none"
                                            }
                                          })}
                                          onClick={async () => {
                                            try {
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}.loading`,
                                                true
                                              );
                                              const maskedAadhaarResponse = (await dispatch(
                                                getMaskedAadhaar({
                                                  fileId: doc.documentId,
                                                  applicationId: application?.id || '',
                                                  applicantId: application?.applicants[ind].id || '',
                                                })
                                              )) as unknown as MaskedAadhaarResponse;
                                              const { loading, file, ...rest } =
                                                values.applicants[ind].documents[doc_index].documentsList[
                                                index
                                                ];
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}`,
                                                {
                                                  ...rest,
                                                  loading: false,
                                                  documentId: maskedAadhaarResponse.id,
                                                  ...(rest.id && { file }),
                                                }
                                              );
                                              if (maskedAadhaarResponse.id) {
                                                enqueueSnackbar('Aadhaar masked Successfully', {
                                                  variant: 'success',
                                                  autoHideDuration: 3000,
                                                });
                                              }
                                            } catch (e) {
                                              setFieldValue(
                                                `applicants.${ind}.documents.${doc_index}.documentsList.${index}.loading`,
                                                false
                                              );
                                              console.error((e as Error).message);
                                            }
                                          }}
                                          disabled={
                                            !doc.documentName.includes('Aadhaar Card') ||
                                            doc.documentId === '' ||
                                            isFieldDisabled
                                          }>
                                          Mask Aadhaar
                                        </LoadingButton> */}
                                    <LoadingButton
                                      type="submit"
                                      loading={
                                        values.applicants[ind].documents[doc_index].documentsList[index].loading
                                      }
                                      variant="contained"
                                      sx={(theme: Theme) => ({
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        ...theme.typography.subtitle_600,
                                        color: theme.palette.primary[500],
                                        backgroundColor: theme.palette.primary[50],
                                        borderRadius: "5px",
                                        border: `0.5px solid ${theme.palette.primary[500]}`,
                                        padding: "5px 10px",
                                        '&:hover': {
                                          backgroundColor: theme.palette.primary[50],
                                          opacity: 0.7
                                        },
                                        "&.Mui-disabled": {
                                          border: "none"
                                        }
                                      })}
                                      onClick={async () => {
                                        try {
                                          setFieldValue(
                                            `applicants.${ind}.documents.${doc_index}.documentsList.${index}.loading`,
                                            true
                                          );
                                          const maskedAadhaarResponse = (await dispatch(
                                            getMaskedAadhaar({
                                              fileId: doc.documentId,
                                              applicationId: application?.id || '',
                                              applicantId: application?.applicants[ind].id || '',
                                            })
                                          )) as unknown as MaskedAadhaarResponse;
                                          const { loading, file, ...rest } =
                                            values.applicants[ind].documents[doc_index].documentsList[
                                            index
                                            ];
                                          setFieldValue(
                                            `applicants.${ind}.documents.${doc_index}.documentsList.${index}`,
                                            {
                                              ...rest,
                                              loading: false,
                                              documentId: maskedAadhaarResponse.id,
                                              ...(rest.id && { file }),
                                            }
                                          );
                                          if (maskedAadhaarResponse.id) {
                                            enqueueSnackbar('Aadhaar masked Successfully', {
                                              variant: 'success',
                                              autoHideDuration: 3000,
                                            });
                                          }
                                        } catch (e) {
                                          setFieldValue(
                                            `applicants.${ind}.documents.${doc_index}.documentsList.${index}.loading`,
                                            false
                                          );
                                          console.error((e as Error).message);
                                        }
                                      }}
                                      disabled={
                                        !doc.documentName.includes('Aadhaar Card') ||
                                        doc.documentId === '' ||
                                        isFieldDisabled
                                      }>
                                      {values.applicants[ind].documents[doc_index].documentsList[index].loading && (
                                        <CircularProgress size={20} color="inherit" />
                                      )}

                                      Mask Aadhaar

                                    </LoadingButton>

                                  </Grid>
                                )}
                            </FileUpload>
                            {index > 0 && !doc.documentId && (
                              <DeleteOutlineIcon
                                onClick={() => {
                                  const getDocs = values.applicants[ind].documents[
                                    doc_index
                                  ].documentsList.filter((_, i) => i !== index);
                                  setFieldValue(
                                    `applicants.${ind}.documents.${doc_index}.documentsList`,
                                    getDocs
                                  );
                                }}
                                color="error"
                                sx={{
                                  alignSelf: 'end',
                                  position: 'relative',
                                  bottom: '95px',
                                  left: '22px',
                                  cursor: 'pointer',
                                }}
                              />
                            )}
                          </React.Fragment>
                        ))}
                        {multipleFiles === 'true' && documentsList.length < maxFiles && (
                          <Typography
                            onClick={() => {
                              const currentDocTypeListLength =
                                values.applicants[ind].documents[doc_index].documentsList.length;
                              const {
                                required = true,
                                documentType,
                                documentName,
                                documentId,
                                maxFiles,
                                options,
                                expiryDate
                              } = values.applicants[ind].documents[doc_index].documentsList[
                                currentDocTypeListLength - 1
                                ];
                              try {
                                if (!documentId) {
                                  throw Error(
                                    'Please upload the first document to add more documents'
                                  );
                                }
                                setFieldValue(
                                  `applicants.${ind}.documents.${doc_index}.documentsList`,
                                  [
                                    ...values.applicants[ind].documents[doc_index].documentsList,
                                    {
                                      ...document_object,
                                      uniqueKey:
                                        ind.toString() +
                                        '-' +
                                        doc_index.toString() +
                                        '-' +
                                        currentDocTypeListLength.toString(),
                                      documentType,
                                      documentName,
                                      required,
                                      maxFiles,
                                      options,
                                      expiryDate
                                    },
                                  ]
                                );
                              } catch (e) {
                                dispatch(showError((e as Error).message));
                              }
                            }}
                            sx={{
                              color: '#417850',
                              fontSize: '12px',
                              fontWeight: 500,
                              textDecoration: 'underline',
                              alignSelf: 'end',
                              // position: 'relative',
                              // bottom:
                              //   values.applicants[ind].documents[doc_index].documentsList[
                              //     values.applicants[ind].documents[doc_index].documentsList.length - 1
                              //   ].documentId !== ''
                              //     ? '15px'
                              //     : '50px',

                              // pointerEvents: applicant.documents[
                              //   values.applicants[ind].documents.length - 1
                              // ].documentId
                              //   ? 'all'
                              //   : 'none',
                              cursor: 'pointer',
                            }}>
                            {'Add another document'}
                          </Typography>
                        )}
                      </Grid >
                    </React.Fragment>
                  );
                })}
                {ENABLE_KRA_DOCUMENT_FETCH && USER_ROLES.INVESTOR !== role && (
                  <KraDocument KraDocument={applicant.kraDocument} />
                )}

              </>
            );
          })}


          {values.nominees.map((nominee, ind) => {
            const { nomineedocuments } = nominee;
            return (
              <>
                <Grid item xs={12}>
                  <SubHeading> {getApplicantName(ind + 1, true)} Nominee Document Details</SubHeading>
                </Grid>
                {nomineedocuments.map((document, doc_index) => {
                  const {
                    documentType,
                    documentName,
                    documentsList = [],
                    multipleFiles,
                    options,
                    required,
                    uploadFormats,
                    maxFiles,
                    maxFileSize,
                    minFileSize,
                  } = document;
                  return (
                    <React.Fragment key={`nomineeFrag-${ind}`}>
                      <Grid item xs={12} lg={6}>
                        {options &&
                          documentsList.map((doc, index) => (
                            <React.Fragment key={`nomDocFrag-${index}`}>
                              <Grid xs={12} sm={12}>
                                <MFSelectField
                                  name={`nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}.documentName`}
                                  label={getLabel(
                                    documentName,
                                    documentType,
                                    required,
                                    values,
                                    ind
                                  )}
                                  items={options.map((item: string) => ({
                                    key: item,
                                    value: item,
                                  }))}
                                  disabled={isFieldDisabled}
                                  applyLabelStyles={true}
                                />
                                {/* <TextDatePicker
                                  name="riskProfileDeclarationDate"
                                  label="Expiry Date *"
                                  inputLabelStyles={{
                                    transform: 'unset',
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: 'rgba(0,0,0,0.7)',
                                  }}
                                  placeholder=''
                                  disabled={false}
                                /> */}
                              </Grid>
                            </React.Fragment>
                          ))}
                        {!options && (
                          <>
                            <Typography
                              sx={{
                                color: 'primary.main',
                                fontWeight: 500,
                                mt: documentType === 'investorSignature' ? 4 : 6,
                              }}>
                              {documentName} {required === 'true' ? '*' : ''}
                            </Typography>
                            {/* <TextDatePicker
                              name="riskProfileDeclarationDate"
                              label="Expiry Date *"
                              inputLabelStyles={{
                                transform: 'unset',
                                fontSize: 14,
                                fontWeight: 500,
                                color: 'rgba(0,0,0,0.7)',
                              }}
                              placeholder=''
                              disabled={false}
                            /> */}
                          </>

                        )}
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        {documentsList.map((doc, index) => (
                          <React.Fragment key={`subFrag-${doc.uniqueKey}`}>
                            <FileUpload
                              onFileChange={(value, documentId, removeFile) => {
                                const { file, ...rest } =
                                  values.nominees[ind].nomineedocuments[doc_index].documentsList[
                                  index
                                  ];
                                setFieldValue(
                                  `nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}`,
                                  {
                                    ...rest,
                                    documentId,
                                    ...(!removeFile && { file }),
                                  }
                                );
                              }}
                              name={`nominees.${ind}.nomineedocuments.${doc_index}.documentsList.${index}.documentId`}
                              documentData={doc}
                              disabled={isFieldDisabled}
                              onFileUpload={handleUpload}
                              onFileUploaded={handleUploaded}
                              fileUploadFormats={uploadFormats}
                              maxUploadFiles={maxFiles}
                              maxFileSize={maxFileSize}
                              minFileSize={minFileSize}
                              multipleFilesCheck={multipleFiles}
                            />
                          </React.Fragment>
                        ))}
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </>
            );
          })
          }

          <Grid item xs={12} my={2} />
          <ProceedSaveLater
            saveButtonText={
              isFieldDisabled || USER_ROLES.AMCAPPROVER === role ? 'Save Application' : 'Continue'
            }
            // saveButtonText={
            //   isFieldDisabled || USER_ROLES.AMCAPPROVER === role
            //     ? 'Save Application'
            //     : values.hasPOA
            //     ? 'Send to POA Approver'
            //     : // : (application?.status === 'draft' ||
            //     //     application?.status === 'sent_to_amc_approver') &&
            //     AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role)
            //     ? 'Send to Checker'
            //     : 'Send to Investor'
            // }
            showEndIcon={false}
            saveLater={() => {
              setFieldValue('saveType', 'save for later');
            }}
            // saveAndProceed={async () => {
            //   try {
            //     if (![USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)) {
            //       await isFormValidForSubmission(application, false);
            //       const error = await validateForm();
            //       if (!Object.keys(error).length) {
            //         history.push(`/application-details/${application?.id}`);
            //         //setDialog(true);
            //       }
            //       setTouched(setNestedObjectValues(error, true));
            //       setErrors(error);
            //     }
            //   } catch (e) {
            //     dispatch(showError(e as string));
            //   }
            // }}
            //saveAndProceedType={isFieldDisabled ? 'submit' : 'button'}
            loader={loading}
            clickedButton={values.saveType}
            showSaveForLater={
              isFieldDisabled ? false : USER_ROLES.AMCAPPROVER === role ? false : true
            }
            disabled={documentUpload}
            saveAndProceed={() => setFieldValue('saveType', 'save and proceed')}

          />
        </Grid >
      )}
    </Formik >
  );
}
